import { z } from 'zod';

import { PromocodesOfferType } from '@occc/graphql';

import {
  PromocodeSchema,
  PromoCodeGroupFormSchema,
  PromocodesSchema,
  configurationSchema,
} from './promocodes-configuration.schema';

export type PromoCodeGroupFormValues = z.infer<typeof PromoCodeGroupFormSchema>;

export type PromocodesConfigureFormValues = z.infer<typeof configurationSchema>;

export type PromocodesConfigureFormInitialValues = Partial<PromocodesConfigureFormValues>;

export type PromocodeFormValues = z.infer<typeof PromocodeSchema>;

export type PromocodesFormValues = z.infer<typeof PromocodesSchema>;

export type PromocodesGlobalFormValues = PromocodesFormValues & {
  codesType: PromocodesOfferType.Global;
  promocodes: PromocodeFormValues[];
};

export type PromocodesIndividualFormValues = PromocodesFormValues & {
  codesType: PromocodesOfferType.Individual;
};

export type PromocodesTargetFormValues = {
  promocodes?: PromocodesFormValues;
  promoCodeGroups?: PromoCodeGroupFormValues[];
};

export const isPromocodesGlobalFormValues = (
  values: PromocodesFormValues,
): values is PromocodesGlobalFormValues => values.codesType === PromocodesOfferType.Global;

export const isPromocodesIndividualFormValues = (
  values: PromocodesFormValues,
): values is PromocodesIndividualFormValues => values.codesType === PromocodesOfferType.Individual;
